From:

<app-roles-icon size="16px" backgroundSize="20px"></app-roles-icon>

<span>{{ name }}</span>
